<template>
  <section class="search-wrapper--experiences-outlet">
    <el-card
      v-for="item in items"
      :key="item.uuid"
      class="box-card container--box-card-custom-outlet"
      shadow="never"
    >
      <LadSearchExperiencesLink :item="item" :route-name="routeName">
        <div class="container-space-card">
          <div>
            <div class="experience-header-info">
              <div class="experience-days">{{
                $tc(`experience.slider.h2_days`, item.days, {
                  days: item.days,
                })
              }}</div>
              <div
                class="experience-review"
                :class="{ 'without-reviews': !!!item.reviews.count }"
              >
                <p v-if="!!item.reviews.value">
                  <i class="fas fa-star"></i>
                  <span class="review-score">{{ item.reviews.value }}</span>
                  <span v-if="!!item.reviews.count" class="review-total"
                    >({{ item.reviews.count }})</span
                  ></p
                >
                <div v-else></div>
                <svg-icon
                  v-if="item.is_lad"
                  :name="`local-exclusive/local-exclusive-vertical`"
                  class="sprite-icons"
                />
              </div>
            </div>

            <h3 class="experience-name"
              ><template v-if="hasName(item)">{{ item.name }}</template
              ><template v-else-if="isProduct(item)">{{
                item.title
              }}</template></h3
            >

            <div class="experience-includes">
              <el-tag
                v-if="item.includes.flights"
                class="with-flight"
                effect="dark"
                size="mini"
              >
                <i class="fas fa-plane"></i
                >{{ $t('search.custom.with_flights') }}
              </el-tag>

              <div v-if="item.includes.dinner" class="icon-container">
                <i class="fas fa-mug-hot"></i>
              </div>
              <div v-if="item.includes.lunch" class="icon-container">
                <i class="fas fa-utensils"></i>
              </div>
              <div v-if="item.includes.breakfast" class="icon-container">
                <i class="fas fa-bread-slice"></i>
              </div>
              <div v-if="item.includes.extra_expenses" class="icon-container">
                <i class="fas fa-coins"></i>
              </div>
              <div v-if="item.includes.sites_tickets" class="icon-container">
                <i class="fas fa-ticket-alt"></i>
              </div>
              <div v-if="item.includes.lodging" class="icon-container">
                <i class="fas fa-hotel"></i>
              </div>
              <div v-if="item.includes.guide" class="icon-container">
                <i class="fas fa-hiking"></i>
              </div>
              <div v-if="item.includes.transportation" class="icon-container">
                <i class="fas fa-bus"></i>
              </div>
            </div>

            <p v-if="hasLanguages(item)" class="experience-languages"
              >{{ $t('search.custom.languages.title') }}:
              <span v-if="item.languages.language_es"
                >🇲🇽 {{ $t('search.custom.languages.es') }}</span
              >
              <span v-if="item.languages.language_en"
                >🇺🇸 {{ $t('search.custom.languages.en') }}</span
              >
              <span v-if="item.languages.language_other"
                ><i class="fas fa-globe" />
                {{ $t('search.custom.languages.other') }}</span
              >
            </p>

            <div class="experience-price-with-image">
              <div>
                <LadSearchPriceExperienceCustom :item="item" />
              </div>
              <div class="container-image-cover">
                <LadImage
                  :src="item.media.data.url"
                  :max-width="110"
                  :min-height="110"
                  :quality="85"
                  :alt="item.name || item.title"
                  :title="
                    item.country
                      ? $t(`${base}.images.title`, {
                          country: item.country.name,
                        })
                      : ''
                  "
                />
              </div>
            </div>
          </div>
          <div>
            <div class="cta-container">
              <el-button
                class="cta-itinerary"
                type="primary"
                plain
                @click.stop.prevent="handleOpenItinerary(item)"
                >{{ $t('search.custom.download_itinerary') }}</el-button
              >

              <nuxt-link
                :to="
                  item
                    | currentPermalink(
                      $t(`router.product_permalink.type.${item.type}`),
                      isOutlet,
                      routeName
                    )
                "
                class="el-button el-button--success el-button--medium cta-show-tour"
                @click.native="handlerClick(item)"
                >{{ $t('search.custom.show_tour') }}</nuxt-link
              >
            </div>
          </div>
        </div>
      </LadSearchExperiencesLink>
    </el-card>

    <client-only>
      <LadItineraryDownloadDialogZoho
        v-if="dialogs.itinerary.show && dialogs.itinerary.item"
        :open="dialogs.itinerary.show"
        :item="dialogs.itinerary.item"
        @close="handleCloseItinerary"
      />
    </client-only>
  </section>
</template>

<script>
import LadItineraryDownloadDialogZoho from '@/components/itinerary/download/components/dialog-zoho'

export default {
  name: 'LadSearchExperiencesOutlet',
  components: {
    LadItineraryDownloadDialogZoho,
    LadSearchPriceExperienceCustom: () =>
      import(
        /* webpackChunkName: "lad-search-price-experience-custom" */ './price'
      ),
    LadSearchExperiencesLink: () =>
      import(
        /* webpackChunkName: "lad-search-experiences-link" */ './experiences-link'
      ),
  },
  filters: {
    currentPermalink(item, type, isOutlet, routeName) {
      const staticLinks = [
        '0d6898dd-7c38-46be-b3d0-df0599d6e560', // subir-ascenso-al-nevado-de-colima-en-un-dia-desde-guadalajara
        '40463dbc-f3bd-40d9-af4b-e3f7062956a6', // Ascenso-al-Nevado-de-Toluca
        '513aa3a1-d3fe-43b4-8b4d-24193d01f16c', // montanismo-el-Pico-de-Orizaba-desde-cdmx-8e33
        'c5d3a20c-844f-4122-8e8a-b86fa8310aeb', // Ascenso-volcan-iztaccihuatl-cdmx
      ]
      if (isOutlet && staticLinks.includes(item.uuid)) {
        routeName = 'product-permalink'
      }

      return {
        name: routeName,
        params: {
          type: routeName === 'product-permalink' ? type : item.type,
          permalink: item.permalink,
        },
      }
    },
  },
  props: {
    items: { type: Array, required: true, default: () => [] },
    routeName: { type: String, default: 'product-permalink' },
    isOutlet: { type: Boolean, default: false },
    isCustom: { type: Boolean, default: false },
  },
  data() {
    return {
      base: 'components.experience',
      types: [
        'post',
        'location',
        'category',
        'experience',
        'package',
        'itinerary',
      ],
      dialogs: {
        itinerary: {
          show: false,
          item: null,
        },
      },
    }
  },
  computed: {
    type() {
      return this.$route.params.type
    },
  },
  methods: {
    hasName(item) {
      return Reflect.has(item, 'name')
    },
    isProduct(item) {
      return ['experience', 'package'].includes(item.type)
    },
    hasIncludes(item) {
      const includes = Object.assign({}, item.includes)
      return (
        Object.keys(includes).length > 0 &&
        Object.values(includes).some((item) => item === true)
      )
    },
    hasLanguages(item) {
      const languages = Object.assign({}, item.languages)
      delete languages.language_other
      return (
        Object.keys(languages).length > 0 &&
        Object.values(languages).some((item) => item === true)
      )
    },
    hasType(item) {
      return Reflect.has(item, 'type') && this.types.includes(this.item.type)
    },
    hasTo(item) {
      return (
        this.hasType(item) &&
        (Reflect.has(this.to, 'name') || Reflect.has(this.to, 'path'))
      )
    },
    handleOpenItinerary(item) {
      this.dialogs.itinerary.show = true
      this.dialogs.itinerary.item = item
    },
    handleCloseItinerary() {
      this.dialogs.itinerary.show = false
      this.dialogs.itinerary.item = null

      this.$store.dispatch('experience/setLead', {
        preventDoubleSubmit: false,
        sent: false,
      })
    },
    handlerClick(item) {
      if (typeof this.$gtag !== 'undefined' && this.isProduct) {
        let price = item.total_amount

        if (item.promotions.length > 0) {
          const promotion = item.promotions[0]

          const isCurrentPromotion = Date.parse(promotion.end) >= Date.now()

          if (promotion.rules.length > 0) {
            price = promotion.rules[0].condition.includes(this.currency)
              ? item.total_amount * (1 - promotion.value / 100)
              : item.total_amount
          } else if (isCurrentPromotion) {
            price = item.total_amount * (1 - promotion.value / 100)
          }
        }

        this.$gtag('event', 'eec.productClick', {
          ecommerce: {
            click: {
              products: [
                {
                  name: item.title,
                  id: item.uuid,
                  price: price === 0 ? '' : price.toFixed(2).toString(),
                },
              ],
            },
          },
          eventCallback() {
            document.location = this.$route.fullPath
          },
          page_title: this.$metaInfo.title,
          page_location: window.location.href,
        })
      }
    },
  },
}
</script>

<style lang="scss">
section.search-wrapper--experiences-outlet {
  gap: 20px;
  padding: 0 20px;
  display: grid;
  background-color: transparent !important;
  grid-template-columns: 1fr;

  @media (min-width: 768px) {
    padding: 0;
    grid-template-columns: 1fr 1fr;
  }

  // Solo para alinear a la misma altura
  .el-card__body {
    height: 100%;
  }

  // Solo para alinear a la misma altura
  .container-space-card {
    display: grid;
    align-content: space-between;
    height: 100%;
  }

  .container--box-card-custom-outlet {
    border-radius: 10px;
    margin: 0 !important;

    .el-card__body {
      padding: 0;
    }

    .container--box-card-custom-outlet-link {
      cursor: pointer;
      display: block;
      padding: 20px;
      height: 100%;
    }

    .experience-header-info {
      display: grid;
      grid-template-columns: 1fr auto;
      gap: 10px;

      .experience-days {
        font-size: 16px;
        font-weight: 500;
        line-height: 36.6px;
      }

      .experience-review {
        display: grid;
        grid-template-columns: 1fr 30px;
        gap: 5px;
        align-items: center;

        &.without-reviews {
          grid-template-columns: 1fr;
        }

        p {
          margin: 0;

          .fa-star {
            color: #1e9700;
          }

          .review-score {
            font-size: 16px;
            font-weight: 500;
            line-height: 36.6px;
            color: #1e9700;
          }

          .review-total {
            font-size: 16px;
            font-weight: 500;
            line-height: 36.6px;
            color: #909399;
          }
        }

        .sprite-icons {
          max-width: 30px;
          max-height: 30px;
        }
      }
    }

    .experience-name {
      font-size: 22px;
      font-weight: 700;
      line-height: 26.86px;
      color: #221f20;
      margin: 10px 0 0;
    }

    .experience-includes {
      margin: 10px 0 0;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 5px;

      .with-flight {
        height: 27px;
        display: flex;
        align-items: center;
        gap: 5px;
      }

      .icon-container {
        position: relative;
        min-width: 27px;
        min-height: 27px;
        max-width: 27px;
        max-height: 27px;
        border-radius: 5px;
        border: 1.5px solid #3f9efe;

        i {
          position: absolute;
          transform: translate(-50%, -50%);
          top: 50%;
          left: 50%;
          color: #3f9efe;
        }
      }
    }

    .experience-languages {
      margin: 10px 0 0;
    }

    .experience-price-with-image {
      display: grid;
      grid-template-columns: 1fr 110px;
      gap: 10px;
      margin: 10px 0 0;

      .container-image-cover {
        position: relative;
        min-width: 110px;
        max-width: 110px;
        min-height: 110px;
        max-height: 110px;
        border-radius: 50%;

        .lad-image {
          img {
            aspect-ratio: 1;
            border-radius: 50%;
            object-fit: cover;
          }
        }
      }
    }

    .cta-container {
      display: grid;
      gap: 10px;
      margin-top: 10px;

      .el-button + .el-button {
        margin: 0;
      }
    }
  }
}
</style>
